<script setup lang="ts">
defineProps({ blok: Object })
</script>

<template>
    <article
        class="story"
    >
        <StoryHero
            v-if="blok"
            :title="blok.title"
            :kind="blok.kind"
            :image="blok.image"
        />
        <StoryblokComponent
            v-for="item in blok?.content"
            :key="item._uid"
            v-editable="item"
            :blok="item"
        />
    </article>
</template>
